import { decorate, injectable } from 'inversify';
import { Logger } from '@wk/office-companion-js-common';

decorate(injectable(), Logger);

@injectable()
export class LoggerService extends Logger {}
